<div class="page-4-elements">
  <div class="calculator__left window-2 cargo_pickup_inner active page-4-one-block">
    <div class="page-4-block">
      <div class="calculator__right-top">
        <div class="calculator__right-title">Настройки оплаты</div>
      </div>
        <div class="package-place-area">
          <el-tabs v-model="selectedTab" type="card" closable class="calculator__spot__buttons__wrapper" @edit="cargoSpaceTabsDelete">
            <el-tab-pane v-for="(card, idx) in payerCards" :key="card.id"
              :label="`Плательщик №${idx + 1}`"
              :name="card.id">
              <el-collapse-transition name="el-fade-in-linear">
                <!-- Контент - Таб -->
                <el-form-item class="vertical">
                  <el-form-item prop="payment.whoPaysForCargoTransportation">
                    <el-radio-group class="calculator__payer__buttons calculator__payer__buttons_type_three"
                      :model-value="card.person" @change="onPersonChange(card, $event)">
                      <el-radio-button v-for="option in availablePartners" :key="option.value" :label="option.label"
                        :disabled="checkingPresenceThirdPerson(option.label)" class="calculator__payer__button"/>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="payment.typeOfPaymentForCargoTransportation">
                    <el-radio-group class="calculator__payer__buttons"
                      :model-value="card.paymentType" @change="onPaymentTypeChange(card, $event)">
                      <el-radio-button v-for="option in optionsTypeOfPayment" :key="option.value" :label="option.label"
                        :disabled="option.value === 'CashlessPayments' && card.disableCashless" class="calculator__payer__button"/>
                    </el-radio-group>
                  </el-form-item>
                  <!-- Опции -->
                  <div :class="card.error ? 'error-nature' : ''">
                    <p class="order-creation-form__label">За что платит?</p>
                    <el-form-item class="calculator__toggle">
                      <div class="calculator__toggle-title">Межтерминальная перевозка</div>
                      <el-switch @change="onServiceToggle(card, 'transport')" v-model="card.services.transport"/>
                    </el-form-item>
                    <el-form-item class="calculator__toggle" v-if="dataForm.applicationCargoPickup.isCargoPickup">
                      <div class="calculator__toggle-title">Забор груза</div>
                      <el-switch @change="onServiceToggle(card, 'pickup')" v-model="card.services.pickup"/>
                    </el-form-item>
                    <el-form-item class="calculator__toggle" v-if="dataForm.applicationCargoPickup.deliveryToTheAddress">
                      <div class="calculator__toggle-title">Доставка груза</div>
                      <el-switch @change="onServiceToggle(card, 'delivery')" v-model="card.services.delivery"/>
                    </el-form-item>
                    <div class="error-label" v-if="card.error">{{ card.error }}</div>
                  </div>
                </el-form-item>
                <!-- Контент - Таб - Завершение -->
              </el-collapse-transition>
            </el-tab-pane>
          </el-tabs>
          <div class="calculator__addSpotButton" v-if="payerCards.length < 2 && activeServices.length > 1" @click="addTab">+</div>


        </div>
    </div>
  </div>
</div>


<div class="calculateArrow">
  <div class="step-counter">4/{{ dataForm.totalSteps }}</div>
  <div class="arrows-steps-prev" @click="$emit('click-button-back')"></div>
  <div class="arrows-steps-next"
  @click="$emit('click-button-next', null, validatePayers())"
  >
  </div>
</div>
